import * as React from 'react';

import Pagination from 'react-js-pagination';

import './Custom-paginator.scss';

import leftArrow from '../../../assets/leftArrow';
import rightArrow from '../../../assets/rightArrow';
import leftChevron from '../../../assets/leftChevron';
import rightChevron from '../../../assets/rightChevron';
import i18n from 'src/translation/i18n';
interface IPaginatorProps {
  activePage: number;
  totalPages: number;
  totalItems: number;
  itemsPerPage: number;
  onPageChanged(event: any): void;
  showPageRangeChange?: boolean;
  pageOption?: number[];
  onPageSizeChange?(event: any): any;
  showPageInfo?: boolean;
  currentPageSize?: number;
}

class CustomPaginator extends React.Component<IPaginatorProps, any> {
  public defaultPageSize: number = 20;

  public render() {
    return this.props.totalPages !== 0 ? (
      <div className="paginator-container">
        {this.props.showPageRangeChange ? (
          <div className="page-options-container">
            {i18n.t('invoices.show')}{' '}
            <select
              className="page-option-selector"
              name="page-range-selctor"
              id="range-selctor"
              value={
                this.props.currentPageSize
                  ? this.props.currentPageSize
                  : this.defaultPageSize
              }
              onChange={e => {
                e.persist();
                this.props.onPageSizeChange(e.target.value);
              }}
            >
              {this.getDefaultPageSizes().map((pageOption: number) => (
                <option
                  key={pageOption}
                  className="page-option"
                  value={pageOption}
                >
                  {pageOption}
                </option>
              ))}
            </select>
          </div>
        ) : (
          ''
        )}
        <div className="rp-paginator-custom">
          <Pagination
            activePage={this.props.activePage}
            totalItemsCount={this.props.totalItems}
            itemsCountPerPage={this.props.itemsPerPage}
            pageRangeDisplayed={4}
            onChange={this.props.onPageChanged}
            prevPageText={<img className="navigation-icons" src={leftArrow} />}
            nextPageText={<img className="navigation-icons" src={rightArrow} />}
            firstPageText={
              <img className="navigation-icons" src={leftChevron} />
            }
            lastPageText={
              <img className="navigation-icons" src={rightChevron} />
            }
          />
        </div>
        {this.props.showPageInfo ? (
          <div className="page-info-container">
            <span className="page-info">
              {i18n.t('invoices.of')} {this.props.totalPages}{' '}
              {i18n.t('invoices.pagess')}
            </span>
          </div>
        ) : (
          ''
        )}
      </div>
    ) : (
      <span />
    );
  }

  public getDefaultPageSizes = (): number[] => {
    if (this.props.pageOption?.length) {
      return this.props.pageOption;
    }
    return [10, 20, 30, 40, 50];
  };
}

export default CustomPaginator;
